import React from 'react';
import { Payment, statusStyles } from '../paymentsTypes';
import { PaymentMethodBadge } from './PaymentMethodBadge';
import styles from './PaymentTable.module.css';

interface PaymentTableProps {
  items: Payment[];
}

export const PaymentTable: React.FC<PaymentTableProps> = ({ items }) => {
  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>PAYMENT ID</th>
            <th>CUSTOMER</th>
            <th>INVOICE #</th>
            <th>METHOD</th>
            <th className={styles.right}>AMOUNT</th>
            <th>DATE</th>
            <th>REFERENCE</th>
            <th>STATUS</th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 ? (
            <tr>
              <td colSpan={8} className={styles.empty}>No payments found.</td>
            </tr>
          ) : (
            items.map((p, idx) => {
              const sc = statusStyles[p.status];
              return (
                <tr key={idx}>
                  <td>
                    <span className={styles.idLink}>{p.paymentId}</span>
                  </td>
                  <td className={styles.customerName}>{p.customer}</td>
                  <td>
                    <span className={styles.invoiceLink}>{p.invoiceNumber}</span>
                  </td>
                  <td>
                    <PaymentMethodBadge method={p.method} />
                  </td>
                  <td className={`${styles.right} ${styles.amount}`}>{p.amount}</td>
                  <td className={styles.date}>{p.date}</td>
                  <td className={styles.reference}>{p.reference}</td>
                  <td>
                    <span className={styles.status} style={{ color: sc.color }}>
                      {p.status}
                    </span>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};
